import BaseSelector, { hookFromSelector, withStaticSelector } from './BaseSelector'

class QuizQuestionsSelector extends BaseSelector {
	static fromStoreState(store) {
		return new this(store.quiz.questions)
	}

	@hookFromSelector('useLoading')
	@withStaticSelector
	selectLoading() {
		return this.state.loading
	}

	@hookFromSelector('useUpdating')
	@withStaticSelector
	selectUpdating() {
		return this.state.updating
	}

	@hookFromSelector('useQuestions')
	@withStaticSelector
	selectQuestions() {
		return this.state.questions
	}

	@hookFromSelector('useCategories')
	@withStaticSelector
	selectCategories() {
		return this.state.categories
	}

	@hookFromSelector('useQuestionIds')
	@withStaticSelector
	selectQuestionIds() {
		return this.selectQuestions().ids
	}

	@hookFromSelector('useQuestionEntities')
	@withStaticSelector
	selectQuestionEntities() {
		return this.selectQuestions().entities
	}

	@hookFromSelector('useIsQuestionsEmpty')
	@withStaticSelector
	selectIsQuestionsEmpty() {
		return _.isEmpty(this.selectQuestionIds())
	}

	@hookFromSelector('useQuestion')
	@withStaticSelector
	selectQuestion(id) {
		return id ? this.selectQuestionEntities()[id] : undefined
	}

	@hookFromSelector('useError')
	@withStaticSelector
	selectError() {
		return this.state.error
	}

	@hookFromSelector('useQuestionAnswerType')
	@withStaticSelector
	selectQuestionAnswerType(id) {
		return this.selectQuestion(id)?.answer_type
	}

	@hookFromSelector('useQuestionField')
	@withStaticSelector
	selectQuestionField({ id, name }) {
		return name ? this.selectQuestion(id)?.[name] : undefined
	}

	@hookFromSelector('useQuestionSettings')
	@withStaticSelector
	selectQuestionSettings(id) {
		return this.selectQuestion(id)?.settings
	}

	@hookFromSelector('useQuestionSettingsValue')
	@withStaticSelector
	selectQuestionSettingsValue({ id, name }) {
		return name ? this.selectQuestionSettings(id)?.[name] : undefined
	}

	@hookFromSelector('useQuestionOptions')
	@withStaticSelector
	selectQuestionOptions(id) {
		return this.selectQuestion(id)?.options
	}

	@hookFromSelector('useQuestionOptionsSize')
	@withStaticSelector
	selectQuestionOptionsSize(id) {
		return _.size(this.selectQuestionOptions(id))
	}

	@hookFromSelector('useQuestionRequired')
	@withStaticSelector
	selectQuestionRequired(id) {
		return this.selectQuestion(id)?.required
	}

	@hookFromSelector('useCategoryIds')
	@withStaticSelector
	selectCategoryIds() {
		return this.selectCategories().ids
	}

	@hookFromSelector('useCategoryEntities')
	@withStaticSelector
	selectCategoryEntities() {
		return this.selectCategories().entities
	}

	@hookFromSelector('useIsCategoriesEmpty')
	@withStaticSelector
	selectIsCategoriesEmpty() {
		return _.isEmpty(this.selectCategoryIds())
	}

	@hookFromSelector('useCategory')
	@withStaticSelector
	selectCategory(id) {
		return id ? this.selectCategoryEntities()[id] : undefined
	}

	@hookFromSelector('useCategoryField')
	@withStaticSelector
	selectCategoryField(id, name) {
		return this.selectCategory(id)?.[name]
	}

	@hookFromSelector('useInitialCategories')
	@withStaticSelector
	selectInitialCategories() {
		return this.state.initial.categories
	}

	@hookFromSelector('useInitialQuestions')
	@withStaticSelector
	selectInitialQuestions() {
		return this.state.initial.questions
	}

	@hookFromSelector('useDeletingCategoryIds')
	@withStaticSelector
	selectDeletingCategoryIds() {
		return this.state.deletingCategoryIds
	}

	@hookFromSelector('useIsCategoryDeleting')
	@withStaticSelector
	selectIsCategoryDeleting(id) {
		return !!id && _.includes(this.selectDeletingCategoryIds(), id)
	}

	@hookFromSelector('useDeletingQuestionIds')
	@withStaticSelector
	selectDeletingQuestionIds() {
		return this.state.deletingQuestionIds
	}

	@hookFromSelector('useIsQuestionDeleting')
	@withStaticSelector
	selectIsQuestionDeleting(id) {
		return !!id && _.includes(this.selectDeletingQuestionIds(), id)
	}

	@hookFromSelector('useDeletingOptionIds')
	@withStaticSelector
	selectDeletingOptionIds() {
		return this.state.deletingOptionIds
	}

	optionDependencies
}

export default QuizQuestionsSelector
